module.exports = __webpack_public_path__ + "img/p1500.b7bbae7f.png";